module.exports = "/packs/images/svg/drop_down_gr~3a5a16a2a4487833e8c423a33963c8f7.svg";